import { modelAnalytics } from "../../Models/analytics/analytics";
import { procesamientoDatos } from "../../Controller/analytics/procesamiento-datos"
import { createNewDate } from "../../Controller/APIs/date"
export default class mainViewAnalytics {
    token = '';
    model = '';
    documentUser = [];
    user = "";
    NewdataDlock = {};
    metadata;
    dataUser = {};
    service = {};

    processData;
    model_Analytics = new modelAnalytics();

    /* datos de vista */
    tarjetaPromedio;
    tarjetaRatings;
    tarjetaTime;

    intervalosTiempo;
    promMesa;

    respuestasLine;
    respuestasPolarArea;

    cuestionarios = [];

    comentarios = [];

    procesamientoDat;

    tablaRespuestas = []

    dataListService

    constructor(service,index) {
        this.service = service;
        this.index = index;
        this.dataListService = this.service.listRatinggs[this.index]

    }

    _main() {
       /*  this.verificarData(); */
        this.procesamientoDat = new procesamientoDatos();
        this.reset_data();
        

    }

    

    verificarData() {

        if (!this.dataListService.hasOwnProperty('analytics')) {
            return;
        }

        if (!this.dataListService.analytics.hasOwnProperty('coleccion')) {
            return;
        }

        if (this.dataListService.analytics.coleccion.length == 0) {
            return false;
        }


        this.setDataopc(this.dataListService.analytics.coleccion);
        
        
                
    }
    

   

    crearDataTiempo() {
    }

    getTarjetaRatings() {

        return {
            name: 'Total',
            value: 14,
            size: "col-4",
            style: 'small-box bg-danger',
            icon: "ion ion-ios-people"
        };
    }

    gettarjetaPromedio() {

        return {
            name: 'Promedio',
            value: 20,
            size: "col-4",
            style: 'small-box bg-primary',
            icon: "ion ion ion-pie-graph"
        };


    }

    geTarjetaTime() {

        return {
            name: 'Tiempo promedio de atencion',
            value: 30,
            size: "col-4",
            style: 'small-box bg-danger',
            icon: "ion ion-ios-people"
        };

    }

    get_intervalosTiempo() {
        return {
            name: 'Tiempo promedio de atencion',
            data: {
                labels: ['1', '1', '1', '1', '1', '1', '1', '1', '1',],
                datasets: [{
                    label: "Cantidad",
                    fill: true,
                    lineTension: 0.3,
                    backgroundColor: "rgba(225, 204,230, .3)",
                    borderColor: "rgb(205, 130, 158)",
                    borderCapStyle: "butt",
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: "miter",
                    pointBorderColor: "rgb(205, 130,1 58)",
                    pointBackgroundColor: "rgb(255, 255, 255)",
                    pointBorderWidth: 10,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: "rgb(0, 0, 0)",
                    pointHoverBorderColor: "rgba(220, 220, 220,1)",
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: [0, 2, 40, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }]
            },


        }
    }

    get_promMesa() {

        return {
            name: 'Tiempo promedio de atencion',
            data: {
                labels: ['1', '1', '1', '1', '1', '1', '1', '1', '1',],
                datasets: [{
                    label: "Cantidad",
                    fill: true,
                    lineTension: 0.3,
                    backgroundColor: "rgba(225, 204,230, .3)",
                    borderColor: "rgb(205, 130, 158)",
                    borderCapStyle: "butt",
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: "miter",
                    pointBorderColor: "rgb(205, 130,1 58)",
                    pointBackgroundColor: "rgb(255, 255, 255)",
                    pointBorderWidth: 10,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: "rgb(0, 0, 0)",
                    pointHoverBorderColor: "rgba(220, 220, 220,1)",
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: [0, 2, 40, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }]
            },


        }
    }

    get_respuestaline() {

        return {
            name: "Tendencia mesas line",
            data: {
                labels: [
                    "PREGUNTA",
                ],
                datasets: [
                    {
                        label: "Muy Malo",
                        data: [1],
                        backgroundColor: ["rgba(245, 0, 87, 0.5)"],
                        borderWidth: 1,
                        borderColor: ["rgba(142, 0, 0, 1)"],
                    },
                    {
                        label: "Malo",
                        data: [2],
                        backgroundColor: ["rgba(255, 111, 97, 0.5)"],
                        borderWidth: 1,
                        borderColor: ["rgba(239, 108, 0, 1)"],
                    },
                    {
                        label: "Regular",
                        data: [3],
                        backgroundColor: ["rgba(255, 176, 0, 0.5)"],
                        borderWidth: 1,
                        borderColor: ["rgba(249, 168, 37, 1)"],
                    },

                    {
                        label: "Bueno",
                        data: [4],
                        backgroundColor: ["rgba(0, 208, 132, 0.5)"],
                        borderWidth: 1,
                        borderColor: ["rgba(85, 139, 47, 1)"],
                    },
                    {
                        label: "Muy bueno",
                        data: [5],
                        backgroundColor: ["rgba(0, 191, 165, 0.5)"],
                        borderWidth: 1,
                        borderColor: ["rgba(27, 94, 32, 1)"],
                    }
                ]
            },
        };

    }

    get_respuestasPolarArea() {

        return {
            name: "Tendencia mesas line",
            data: {
                labels: [
                    "Malo",
                    "Muy Malo",
                    "Regular",
                    "Bueno",
                    "Muy bueno",
                ],
                datasets: [
                    {
                        data: [1, 2, 3, 4, 5],
                        backgroundColor: [
                            "rgba(255, 0, 0, 0.5)",
                            "rgba(255, 0, 0, 0.5)",
                            "rgba(247, 252, 0, 0.5)",
                            "rgba(0, 247, 0, 0.5)",
                            "rgba(0, 247, 0, 0.5)",
                        ],
                        label: [`Pregunta`]
                    },
                ],
            },
        };

    }

    get_respuestasComentarios() {

        return {
            name: "Comentarios",
            data: {
            }

        }
    }

    setReset() {
        this.reset_data()
        this.procesamientoDat.reset();
        this.tarjetaPromedio.value = 0;

        this.procesamientoDat.totalMesas = this.service.service.mesasService.length
        this.comentarios = [];

        this.procesamientoDat.conteopormesa = Array.from({ length: this.service.service.mesasService.length - 1 }, (_, i) => 0);
        this.procesamientoDat.numeraciondemesa = Array.from({ length: this.service.service.mesasService.length - 1 }, (_, i) => i + 1);

        this.procesamientoDat.encuesta = []
        this.procesamientoDat.tablaRespuestas = []
    }


    async obtenerDatos(data) {
        let date = await createNewDate()
        if (this.service.service.mesasService.length == 0) {
            return
        }
        let f1 = this.separarFecha(data.rangoFechas.f1);
        let f2 = this.separarFecha(data.rangoFechas.f2);
        let index_m = parseInt(f1.m);
        let index_mf2 = 12;
        ;
       


        if (f1.y == f2.y) {
            index_mf2 = f2.m;
        }


        this.setReset()

        for (let index_yF1 = parseInt(f1.y); index_yF1 <= parseInt(f2.y); index_yF1++) {

            for (index_m; index_m <= index_mf2; index_m++) {
                if (date.year == index_yF1 && parseInt(date.month) == index_m) {
                    const current = (this.dataListService.analytics && this.dataListService.analytics.coleccion) || [];
                    this.tarjetaPromedio.value = this.procesamientoDat.tarjetaPromedio(current, this.tarjetaPromedio.value);
                    this.tarjetaRatings.value = current.length + this.tarjetaRatings.value;
                    break;
                }


                let get_data = await this.model_Analytics.obtenerDatos({
                    id: data.id,
                    y: index_yF1.toString(),
                    m: index_m.toString()
                })


                
                if (get_data.status) {

                    this.tarjetaPromedio.value = this.procesamientoDat.tarjetaPromedio(get_data.data.coleccion, this.tarjetaPromedio.value);
                    this.tarjetaRatings.value = get_data.data.coleccion.length + this.tarjetaRatings.value
                }
            }

            if (index_yF1 < parseInt(f2.y)) {
                index_m = 1
                index_mf2 = 12;
                if (index_yF1 + 1 == parseInt(f2.y)) {
                    index_mf2 = f2.m;
                }
            }

        }

        this.setDataView()

    }

    setDataopc(data) {
        
        
        if (data.length == 0) {
            return;
        }
       
        this.procesamientoDat.reset();
        this.setReset();

            this.tarjetaPromedio.value = this.procesamientoDat.tarjetaPromedio(data, this.tarjetaPromedio.value);
            this.tarjetaRatings.value = data.length;

        this.setDataView();
    }



    setDataView() {
        if (!this.tarjetaRatings.value) {
            /* Nothing answered in the period: avoid 0/0 in the averages. */
            this.tarjetaPromedio.value = "00:00:00";
            this.tarjetaTime.value = "—";
            return;
        }
        this.tarjetaPromedio.value = this.procesamientoDat.formatearTiempo(Math.round(this.tarjetaPromedio.value / this.tarjetaRatings.value));
        this.tarjetaTime.value =this.procesamientoDat.getSC(this.tarjetaPromedio.value.split(':')[1]); 
        this.intervalosTiempo.data.labels = this.procesamientoDat.listTiempoPromData
        this.intervalosTiempo.data.datasets[0].data = this.procesamientoDat.listTiempoProm;

        this.promMesa.data.labels = this.procesamientoDat.numeraciondemesa;
        this.promMesa.data.datasets[0].data = this.procesamientoDat.conteopormesa;

        this.cuestionarios = this.procesamientoDat.encuesta;
        this.comentarios = this.procesamientoDat.comentarios;
       
        
        this.tablaRespuestas = this.procesamientoDat.tablaRespuestas;

        
    }

    procesamientoDatos() {

    }

    reset_data() {
        this.tarjetaRatings = {
            name: 'Total de datos',
            value: 0,
            size: "col-12 col-md-4",
            style: 'small-box bg-danger',
            icon: "ion ion-ios-people"
        };

        this.tarjetaTime = {
            name: 'Satisfaccion de clientes',
            value: 0,
            size: "col-12 col-md-4",
            style: 'small-box bg-warning',
            icon: "ion ion ion-pie-graph"
        };

        this.tarjetaPromedio = {
            name: 'Tiempo promedio de atencion',
            value: 0,
            size: "col-12 col-md-4",
            style: 'small-box bg-success',
            icon: "ion ion-ios-clock"
        };

        this.intervalosTiempo = {
            name: 'Historial de tiempo por mesa (Minutos)',
            data: {
                labels: [],
                datasets: [{
                    label: "Tiempo",
                    fill: true,
                    lineTension: 0.3,
                    backgroundColor: "rgba(225, 204,230, .3)",
                    borderColor: "rgb(205, 130, 158)",
                    borderCapStyle: "butt",
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: "miter",
                    pointBorderColor: "rgb(205, 130,1 58)",
                    pointBackgroundColor: "rgb(255, 255, 255)",
                    pointBorderWidth: 10,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: "rgb(0, 0, 0)",
                    pointHoverBorderColor: "rgba(220, 220, 220,1)",
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                }]
            }
        };

        this.promMesa = {
            name: 'Total de pedidos por mesa.',
            data: {
                labels: [],
                datasets: [{
                    label: "Tiempo",
                    fill: true,
                    lineTension: 0.3,
                    backgroundColor: "rgba(225, 204,230, .3)",
                    borderColor: "rgb(205, 130, 158)",
                    borderCapStyle: "butt",
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: "miter",
                    pointBorderColor: "rgb(205, 130,1 58)",
                    pointBackgroundColor: "rgb(255, 255, 255)",
                    pointBorderWidth: 10,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: "rgb(0, 0, 0)",
                    pointHoverBorderColor: "rgba(220, 220, 220,1)",
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                }]
            }
        }



        this.comentarios = [];
    }

    separarFecha(fecha) {
        const [y, m, d] = fecha.split("-");
        return {
            y: y,
            m: m,
            d: d
        };
    }

    timestampToDate(timestamp) {
        return new Date(timestamp.seconds * 1000);
    }
}

